import React from "react";
import { Image, Container } from "react-bootstrap";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import Button from "./Button";
import Burger from "./Burger";
import { goTo } from "../utilities/utils";
import { useSelector } from "react-redux";
import { RootState } from "../redux/reducers/rootReducer";
import { useTranslation } from "react-i18next";

const MobileHeader: React.FC = () => {
  let routeDetails = useSelector((state: RootState) => {
    return state.route;
  });

  const { t } = useTranslation();

  const onPartnerPage = routeDetails.routeString === "partners"
  
  return (
    <Wrapper>
      <Container>
        <NavWrapper>
          <Logo>
            <a onClick={() => {onPartnerPage ? goTo('/partners', undefined, undefined, true) : goTo('/', undefined, undefined, true)}}>
              <Image
                src="/images/logo-mobile.png"
                width="30px"
                height="40px"
                alt="PhoneBox Logo"
              />
            </a>
          </Logo>
          <Cont>
            <Button
              text={onPartnerPage ? t("Partner Portal") : t("My Account")}
              padding="5px 18px !important"
              color="white"
              min="135px"
              centerText={true}
              onClick={() => {onPartnerPage ? window.open("https://partner.gophonebox.com/", "_self") : goTo('/account')}}
            />
          </Cont>
          {!onPartnerPage && <Cont>
            <a onClick={() => goTo('/support')}>
              <FontAwesomeIcon
                icon={faQuestion}
                style={{ fontSize: "20px", color: "#0494CA" }}
              />
            </a>
          </Cont>}
          <Cont>
            <Burger />
          </Cont>
        </NavWrapper>
      </Container>
    </Wrapper>
  );
}

const Cont = styled.div`
  margin-left: 2rem;
  color: #0494ca;

  @media (max-width: 375px) {
    margin-left: 18px;
  }
`;
const Wrapper = styled.div`
  background-color: #fff;
  z-index: 999;
  padding: 25px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
`;

const NavWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.div`
  display: flex;
  flex-grow: 1;
  :hover {
    cursor: pointer;
  }
`;

export default MobileHeader;